import React from 'react';

const CARDS = [
  {
    key: 'nuevosSinAtender',
    label: 'Nuevos sin atender',
    filter: { estatus: 'NUEVO' },
  },
  {
    key: 'seguimientosVencidos',
    label: 'Seguimientos vencidos',
    filter: { seguimientoVencido: 'true' },
  },
  {
    key: 'seguimientosHoy',
    label: 'Seguimientos de hoy',
    filter: { ordenarPor: 'fechaProximoSeguimiento', direccionOrden: 'asc' },
  },
  {
    key: 'calientesSinActividad',
    label: 'Calientes sin actividad',
    filter: { temperatura: 'CALIENTE', ordenarPor: 'fechaUltimaActividad', direccionOrden: 'asc' },
  },
  {
    key: 'actividadesProximas',
    label: 'Citas o actividades proximas',
    filter: { ordenarPor: 'fechaProximoSeguimiento', direccionOrden: 'asc' },
  },
];

export default function ProspectosPendientesCards({ pendientes, onFilter }) {
  return (
    <section className="crm-prospectos-summary" aria-label="Pendientes comerciales">
      {CARDS.map((card) => {
        const value = Number(pendientes?.[card.key] || 0);

        return (
          <button
            key={card.key}
            type="button"
            className="crm-prospectos-summary-card"
            onClick={() => onFilter?.(card.filter)}
          >
            <span>{card.label}</span>
            <strong>{value}</strong>
          </button>
        );
      })}
    </section>
  );
}
